import { Link } from "react-router-dom";
import { LOGO_URL, NAV_LINKS } from "../lib/site";
import NewsletterForm from "./NewsletterForm";

const Footer = () => (
  <footer className="bg-navy text-white" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 sm:py-16">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Telopea Park OSHC Waratah logo" className="h-14 w-14 rounded-full object-cover bg-white p-1" />
            <div className="leading-tight">
              <span className="block font-display text-xl font-bold">Telopea Park OSHC</span>
              <span className="block text-xs uppercase tracking-[0.18em] text-white/60">A Home Away From Home</span>
            </div>
          </div>
          <p className="mt-6 text-base leading-relaxed text-white/75" data-testid="footer-acknowledgement">
            Telopea Park OSHC acknowledges the Ngunnawal people as the Traditional Custodians of the land on which our
            service learns and plays, and pays respect to Elders past and present.
          </p>
        </div>

        <div className="lg:col-span-3">
          <h2 className="text-sm font-semibold uppercase tracking-[0.18em] text-white/60">Explore</h2>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  data-testid={`footer-${link.testId}`}
                  className="text-base text-white/80 transition-colors duration-200 hover:text-white"
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/enrol" data-testid="footer-nav-link-enrol" className="text-base text-white/80 transition-colors duration-200 hover:text-white">
                Enrolment
              </Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-5">
          <h2 className="text-sm font-semibold uppercase tracking-[0.18em] text-white/60">Stay in the loop</h2>
          <p className="mt-5 text-base text-white/75 leading-relaxed">
            Receive occasional email updates about programs, vacation care dates and enrolment news.
          </p>
          <div className="mt-5">
            <NewsletterForm dark />
          </div>
          <p className="mt-6 text-base text-white/75">
            Located on the grounds of Telopea Park School, New South Wales Crescent, Barton ACT 2600.
          </p>
        </div>
      </div>

      <div className="mt-12 border-t border-white/15 pt-8 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <p className="text-sm text-white/60" data-testid="footer-copyright">
          Telopea Park Out of School Hours Care, Barton, Canberra.
        </p>
        <p className="text-sm text-white/60">Rated Exceeding the National Quality Standard (assessed 27 May 2025).</p>
      </div>
    </div>
  </footer>
);

export default Footer;
